import { format, isValid, parseISO } from "date-fns";

export const formatDate = (dateString: string) => {
  const date = parseISO(dateString);
  if (!isValid(date)) return dateString;
  return format(date, "MMM dd, yyyy");
};
